import { Languages } from 'lucide-react'
import { useLocale } from '../context/LocaleContext'

export function LanguagesSection() {
  const { content } = useLocale()
  const { ui, languages } = content

  return (
    <section className="languages-section section-shell" id="languages" aria-labelledby="languages-title">
      <div className="languages-block">
        <div className="languages-heading"><Languages aria-hidden="true" /><h2 id="languages-title">{ui.languagesTitle}</h2></div>
        <div className="languages-list">
          {languages.map((language) => <article key={language.name}><strong>{language.name}</strong><span>{language.level}</span></article>)}
        </div>
      </div>
    </section>
  )
}
